import React from "react";

export interface ControlsWrapperProps {
  children: React.ReactNode;
  direction?: "row" | "column";
}

export const ControlsWrapper: React.FC<ControlsWrapperProps> = ({
  children,
  direction = "column",
  ...props
}) => {
  return (
    <div
      className={`
        flex items-center h-full content-between justify-between
        ${direction === "row" ? "flex-row" : "flex-col"}
        self-start md:self-center pt-1
      `}
      {...props}
    >
      {children}
    </div>
  );
};
